import { observable } from '@legendapp/state';

import type { AppConfig } from '@/core/types';

export const configStore = observable<AppConfig>({} as AppConfig);
